import React from "react";

// core components

import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { bindActionCreators }  from 'redux';


import commonStyle from 'commonStyle';

import { canActionObject } from 'utils';

import ActionsBar from 'components/ActionsBar';
import ScrollView from 'components/ScrollView';

import {
  downloadFile,
  clearSelections,
  deleteObjects,
  checkCheckbox,
  uncheckCheckbox,
  showModal
} from 'api/actions';

import { withSearchLocation } from 'HOC';

import Table from './table';


import {
  GET_OBJECT_SUCCESS,
  GET_OBJECTS,
  GET_OBJECTS_SUCCESS,
  GET_OBJECTS_FAILURE,
  DELETE_OBJECTS,
  DELETE_OBJECTS_SUCCESS,
  DELETE_OBJECTS_FAILURE,
  DESELECT_ROW,
  FILE_UPLOADING_SUCCESS,
  SELECT_ROW
} from 'constants/ActionTypes'

import MODAL_KEYS from 'components/Modals/keys';

import './index.css'


class MainView extends React.PureComponent {
  state = {
    commandPressed: false,
    folder_id: null,
    objects: {},
    page: 0,
    selections: [],
    loading: false,
  }

  constructor(props) {
    super(props);

    this.setState({
      pathname: props.location.pathname
    });
  }

  async componentWillReceiveProps(props) {
    const refresh = this.state.pathname !== props.location.pathname;

    const { done, loading, objects } = props;

    const newState = { loading, done };

    const { page } = this.state;

    switch (props.type) {
      case GET_OBJECTS_SUCCESS:
        if (!newState.done && objects) {
          this.setState({
            objects: Object.assign({}, this.state.objects, objects)
          })
        }
        newState.page = !newState.done ? page + 1 : page;
        break;
      case GET_OBJECT_SUCCESS:
        this.setState({
          objects: Object.assign({}, this.state.objects, objects)
        })
        break;
      case FILE_UPLOADING_SUCCESS:
        this.setState({
          objects: Object.assign({}, this.state.objects, objects)
        })
        break;
    }

    if (refresh) {
      newState.pathname = props.location.pathname;
    }

    this.setState(newState, () => {
      if (refresh) {
        this.onRefresh()
      }
    });
  }

  componentWillMount() {
    let folder_id;

    const match = this.props.match;

    if (match && match.params && match.params.folder_id) {
      folder_id = match.params.folder_id;
    }

    this.props.getObjects({ page: 0, folder_id });

    this.setState({ folder_id });
  }
  
  getFolderId = (props = {}) => {
    let folder_id;

    const match = props.match;

    if (match && match.params && match.params.folder_id) {
      folder_id = match.params.folder_id;
    }

    return folder_id;
  }

  fetchMore = (page = this.state.page, info = {}, options = {}) => {
    const { done, loading } = this.state;

    if (!loading && !done) {
      this.props.getObjects({ page, folder_id: this.state.folder_id }, options);
    }
  };

  renderTable = (info = {}) => {
    return (
      <Table {...info}/>
    )
  }

  onRefresh = async() => {
    await this.resetState();
    await this.props.clearSelections();
    this.props.getObjects({ page: this.state.page, folder_id: this.getFolderId(this.props) });
  }

  onDownload = (objects, selections, props = {}) => () => {
    const selectionsArr = [...selections];
    const file = objects[selectionsArr[0]];

    if (props.downloadFile) {
      props.downloadFile({
        downloadName: file.name,
        id: file.id
      })
    }
  }

  onMove = (objects, selections, props = {}) => () => {
    this.props.showModal({
      modalKey: MODAL_KEYS.MOVE_FILES,
      modalId: 'move_files',
      modalInfo: { files: [...selections].map(id => objects[id])  }
    })
  }

  onDelete = (objects, selections, props = {}) => () => {
    // console.log('DELETE PRESSED', objects, selections)
    this.props.showModal({
      modalKey: MODAL_KEYS.DELETE_FILES,
      modalId: 'delete_files',
      modalInfo: { files: [...selections].map(id => objects[id])  }
    })
  }

  resetState = () => new Promise(resolve => {
    this.setState({
      search: this.props.location.search,
      done: false,
      data: [],
      objects: {},
      page: 0,
      selections: [],
      loading: false,
    }, resolve);
  })

  setCommandKeyDown = (value) => {
    this.setState({ commandPressed: value })
  }

  render() {
    const { commandPressed, loading, objects } = this.state;

    const keys = Object.keys(objects)
    const data = keys.map(key => objects[key]);

    const { checkCheckbox, selections, uncheckCheckbox } = this.props;

    const selectionsSize = selections.size;

    const oneSelected = selectionsSize === 1;
    const multipleSelected = selectionsSize > 1;

    let canDownload = false;
    let canDelete = false;
    let canMove = false;

    if (oneSelected) {
      const permission = canActionObject(objects, selections, ['download'])
      canDownload = permission;
    }

    if (oneSelected || multipleSelected) {
      canDelete = true;
      canMove = true;
    }

    return (
      <div
      className='dashboard__container'
        onKeyDown={(e) => {
          if (e.keyCode === 224) {
              this.setCommandKeyDown(true)
          }
        }}
        onKeyUp={(e) => {
            if (e.keyCode === 224) {
                this.setCommandKeyDown(false)
            }
        }}
        tabIndex='0'
      >
        <p
          className='dashboard__selections-count'
          style={{ visibility: selectionsSize > 0 ? 'visible' : 'hidden'}}
        >
          {selectionsSize} {selectionsSize < 2 ? 'file': 'files'} selected
        </p>
        <div>
          <ActionsBar
            onDownload={canDownload && this.onDownload(objects, selections, this.props)}
            onDelete={canDelete && this.onDelete(objects, selections, this.props)}
            onMove={canMove && this.onMove(objects, selections, this.props)}
            onRefresh={this.onRefresh}
            showLoading
            loading={loading}
          />
          {
            this.renderTable({
              commandPressed,
              checkCheckbox,
              data,
              selections,
              uncheckCheckbox,
              fetchMore: this.fetchMore
            })
          }
        </div>
      </div>
    );
  }
}

MainView.defaultProps = {
  objects: [],
  selections: new Set([])
};

const mapStateToProps = (state) => {
  const body = {
    objects: state.entities ? state.entities.objects : {},
    result: state.result || [],
    selections: state.selections,
    type: state.type,
    preview: state.preview,
  }
  
  switch (state.type) {
    case GET_OBJECTS:
      body.loading = true;
      break;

    case GET_OBJECTS_FAILURE:
      body.loading = false;
      break;

    case GET_OBJECTS_SUCCESS:
      if (state.result.length < 1) body.done = true;
      body.loading = false;
      break;
  }

  return body;
};

const dispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      checkCheckbox,
      clearSelections,
      deleteObjects,
      downloadFile,
      uncheckCheckbox,
      showModal
    }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(withSearchLocation(MainView));
